var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.componentId,{tag:"component",on:{"home":_vm.setHome,"login":_vm.setLogin}}),_c('vue-headful',{attrs:{"title":this.$clienteNomeFantasia + ' | Currículo Web'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }